import { render, staticRenderFns } from "./DayHeader.vue?vue&type=template&id=1c2a4e42&scoped=true&"
import script from "./DayHeader.vue?vue&type=script&lang=ts&"
export * from "./DayHeader.vue?vue&type=script&lang=ts&"
import style1 from "./DayHeader.vue?vue&type=style&index=1&id=1c2a4e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2a4e42",
  null
  
)

export default component.exports